import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { TextField, Box } from "@mui/material";

function CustomInput({ value, onClick, label, error, helperText, readOnly }) {
  return (
    <TextField
      fullWidth
      label={label}
      value={value || ""}
      onClick={readOnly ? undefined : onClick}
      variant="standard"
      InputProps={{
        readOnly: true,
        endAdornment: !readOnly && <FaCalendarAlt style={{ color: "#999" }} />,
      }}
      error={error}
      helperText={helperText}
      sx={{
        '& .MuiInput-underline:before': {
          borderBottomColor: '#ccc',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottomColor: readOnly ? '#ccc' : '#666',
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: '#1976d2',
        },
        '& .MuiInput-underline.Mui-error:after': {
          borderBottomColor: '#d32f2f',
        }
      }}
    />
  );
}

export const Calendar = ({ value, handleChange, fieldName, label = "Select Date", error, helperText, readOnly = false, withPortal, minDate, maxDate, sx }) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  // const minDate = new Date(1950, 0, 1);

  const formatDate = (date) => {
    if (!date) return "";
    try {
      // Format for display (dd/MMM/yyyy)
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleDateString("en-GB", { month: "short" });
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Date formatting error:", error);
      return "";
    }
  };

  // Add a new function to format date for API
  const formatDateForAPI = (date) => {
    if (!date) return null;
    try {
      // Get components
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      // Format as dd/mm/yyyy
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Date API formatting error:", error);
      return null;
    }
  };

  const selectDateHandler = (date) => {
    if (!readOnly && date) {
      // Ensure we're passing a valid Date object
      const newDate = new Date(date);
      if (!isNaN(newDate.getTime())) {
        // Pass both the display date and the formatted date for API
        handleChange(fieldName, newDate, formatDateForAPI(newDate));
      }
    }
  };

  // Ensure value is a valid Date object
  const selectedDate = value instanceof Date && !isNaN(value) ? value : null;
  const displayValue = formatDate(selectedDate);

  return (
    <Box sx={sx}>
      <DatePicker
        dateFormat="dd-MMM-yyyy"
        selected={selectedDate}
        onChange={selectDateHandler}
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        wrapperClassName="date-picker-wrapper"
        customInput={<CustomInput value={displayValue} label={label} error={error} helperText={helperText} readOnly={readOnly} />}
        shouldCloseOnSelect={true}
        disabled={readOnly}
        withPortal={withPortal}
      />
    </Box>
  );
};
